import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import ITradesPoints from "../interfaces/ITradesPoints";
import { generateQueryString } from "src/util/helper";
import { IBaseResponse } from "./IBaseResponse";
import { TradePhaseEnum } from "../interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "../interfaces/TradeStatusEnum";
import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { IQuote } from "../interfaces/trade/precificacao/IQuote";
import { IDocumentUpload } from "../interfaces/IDocumentUpload";
import IBcheckRequest from "../interfaces/IBcheckRequest";
import { IOfficerOperationItem } from "../interfaces/trade/IOfficerOperationItem";

const createParams = (status: TradeStatusEnum[], phases: TradePhaseEnum[]): string => {
  const paramList = [];
  let params = "";
  status.forEach((value, index) => {
    paramList.push(`Status=${TradeStatusEnum[value]}`);
  });
  phases.forEach((value, index) => {
    paramList.push(`Phase=${value}`);
  });
  paramList.forEach((value, index) => {
    params += index === 0 ? value : "&" + value;
  });
  return params;
};

enum TradeServiceEnum {
  getById = "/",
  getAll = "/get-all-from-officer",
  getAllByUser = "/get-all-by-user",
  getManualByStatusAndPhase = "/get-manual-trades?",
  getWithDocumentsByStatusAndPhase = "/get-trades-with-documents-by-status-and-phase?",
  putRequestClickSignSignature = "/request-clicksign-signature",
  postUpdateManualTrade = "/update-manual-trade",
  putMarriageCertificate = "/upload-marriage-certificate",
  editTrade = "/edit-trade",
  postCreateFromQuote = "/create-from-quote",
  putBankingChannelByTradeId = "/banking-channel",
  putUploadLegalCertificates = "/upload-legal-certificates",
  putSendLegalCertificatesToLawyer = "/send-legal-certificates-to-lawyer",
  putUploadCessionContract = "/upload-cession-term-contract",
  putUploadAcceptenceTermContract = "/upload-acceptence-term-contract",
  putUploadDocument = "/upload-document",
  putUploadInvoice = "/upload-invoice",
  getOfficerPoints = "/get-officer-points",
  putSpouseIdDoc = "/upload-spouse-id-doc",
  putArchiveTrade = "/archive-trade",
  realodBackgroundCheck = "/reload-background-check"
}

export default class TradeService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade");
  }
  public getById = async (tradeId: number): Promise<ITrade> => await this.GET(TradeServiceEnum.getById + tradeId);
  public getAllOperations = async (): Promise<IOfficerOperationItem[]> => await this.GET(TradeServiceEnum.getAll);
  public getAllByUser = async (): Promise<ITrade[]> => await this.GET(TradeServiceEnum.getAllByUser);
  public getManualByStatusAndPhase = async (status: TradeStatusEnum[], phases: TradePhaseEnum[]) =>
    await this.GET(TradeServiceEnum.getManualByStatusAndPhase + createParams(status, phases));
  public getWithDocumentsByStatusAndPhase = async (status: TradeStatusEnum[], phases: TradePhaseEnum[]) =>
    await this.GET(TradeServiceEnum.getWithDocumentsByStatusAndPhase + createParams(status, phases));
  public putRequestClickSignSignature = async (trade: ITrade) => await this.PUT(TradeServiceEnum.putRequestClickSignSignature, trade);
  public postUpdateManualTrade = async (trade: ITrade, updateBankData: boolean): Promise<IBaseResponse> =>
    await this.POST(`${TradeServiceEnum.postUpdateManualTrade}?${generateQueryString({ updateBankData })}`, trade);
  public updateReLoadBackGroundCheck = async (request: IBcheckRequest) => await this.POST(TradeServiceEnum.realodBackgroundCheck, request);
  public putMarriageCertificate = async (file: any, tradeId: number, fileName: string) => {
    const document = {
      id: 0,
      category: "MARRIAGE_CERTIFICATE",
      file,
      description: "Certidao de casamento/União Estável",
      storageType: "S3",
      tradeId,
      fileName
    };
    return await this.PUT(TradeServiceEnum.putMarriageCertificate, document);
  };
  public editTrade = async (trade: ITrade): Promise<ITrade> => await this.PUT(TradeServiceEnum.editTrade, trade);
  public postCreateFromQuote = async (quote: Partial<IQuote>): Promise<ITrade> => await this.POST(TradeServiceEnum.postCreateFromQuote, quote);
  public putBankingChannelByTradeId = async (id: number, trade): Promise<IBaseResponse> =>
    await this.PUT(TradeServiceEnum.putBankingChannelByTradeId.replace("{tradeId}", id.toString()), trade);
  public putUploadLegalCertificates = async (document): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.putUploadLegalCertificates, document);
  public putSendLegalCertificatesToLawyer = async (data): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.putSendLegalCertificatesToLawyer, data);
  public putUploadCessionTermContract = async document => await this.PUT(TradeServiceEnum.putUploadCessionContract, document);
  public putUploadAcceptenceTermContract = async document => await this.PUT(TradeServiceEnum.putUploadAcceptenceTermContract, document);
  public putUploadDocument = async (document: IDocumentUpload) => await this.PUT(TradeServiceEnum.putUploadDocument, document);
  public putUploadInvoice = async document => await this.PUT(TradeServiceEnum.putUploadInvoice, document);
  public getOfficerPoints = async (): Promise<ITradesPoints> => await this.GET(TradeServiceEnum.getOfficerPoints);
  public putSpouseIdDoc = async (file: any, tradeId: number, fileName: string) => {
    const document = {
      id: 0,
      category: DocumentCategoryEnum.ID_SPOUSE,
      file,
      description: "RG do cônjuge",
      storageType: "S3",
      tradeId,
      fileName
    };
    return await this.PUT(TradeServiceEnum.putSpouseIdDoc, document);
  };
  public putArchiveTrade = async (data: { archiveOrNot: boolean; tradeId: number }): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.putArchiveTrade, data);
}



// WEBPACK FOOTER //
// ./src/services/api/Trade.service.ts